import { prefetchCustomerPlaidLinkRetrieveQuery } from "@boundless/bl-api-client/customer/services"
import { createFileRoute, redirect } from "@tanstack/react-router"

import {
  PlaidConnectCard,
  isUnexpectedError,
} from "@/components/analytics/PlaidConnectCard"
import { PlaidInfoCard } from "@/components/analytics/PlaidInfoCard"
import type { ErrorType } from "@/lib/clients"

import type { PlaidLinkTokenError } from "@boundless/bl-api-client/customer/models"

export const Route = createFileRoute("/_dashboard/company/plaid")({
  component: PlaidConnectView,
  beforeLoad: ({ context: { store, hasPermissions } }) => {
    if (!hasPermissions(["analytics.view_heronlink"])) {
      throw redirect({ to: "/" })
    }
    const companyUuid = store.getState().activeCompanyUuid
    if (!companyUuid) {
      throw redirect({ to: "/home" })
    }
    return { companyUuid }
  },
  loader: ({ context: { companyUuid, queryClient } }) => {
    prefetchCustomerPlaidLinkRetrieveQuery(queryClient, companyUuid, {
      query: {
        meta: {
          // Keep Plaid errors that we handle locally from triggering the global error toast.
          shouldDisplayErrorToast: (error) => {
            return isUnexpectedError(error as ErrorType<PlaidLinkTokenError>)
          },
        },
      },
    })
  },
  onError: () => {
    throw redirect({ to: "/home" })
  },
})

function PlaidConnectView() {
  return (
    <div className="@container">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-5">
        <PlaidConnectCard />
        <PlaidInfoCard />
      </div>
    </div>
  )
}
